import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class LevelService {
  constructor (private readonly httpClient: HttpClient) { }
  private readonly url: string = environment.url

  getLevel (): Observable<any> {
    return this.httpClient.get(`${this.url}/users/level`)
  }
}
